// @ts-nocheck

import Lara from '@primevue/themes/lara';
import Aura from '@primevue/themes/aura';

export const preset = {
  ...Lara,
  primitive: {
    ...Lara.primitive,
    brand: {
      400: '#F9CF2C',
    },
    slate: {
      ...Lara.primitive.slate,
      300: '#475467',
    },
    emerald: {
      ...Lara.primitive.emerald,
      200: 'transparent',
    },
    gray: {
      ...Lara.primitive.gray,
      50: '#f9fafb',
      100: '#F2F4F7',
      200: '#EAECF0',
      300: '#D0D5DD',
      500: '#667085',
      600: '#475467',
      700: '#344054',
      800: '#182230',
      900: '#101828',
    },
    'gray-iron': {
      700: '#3F3F46',
    },
  },
  semantic: {
    ...Lara.semantic,
    colorScheme: {
      light: Lara.semantic.colorScheme.light,

      dark: Lara.semantic.colorScheme.light,
    },
    primary: {
      ...Lara.semantic.primary,
      50: '#FEFCE8',
      200: '#FDEF8B',
      300: '#fcde48',
      500: '{brand.400}',
      600: '#ffcb00',
    },
  },
  components: {
    ...Lara.components,
    accordion: {
      ...Lara.components.accordion,
      header: {
        ...Lara.components.accordion.header,
        color: '{gray-iron.700}',
        hoverColor: '{gray.800}',
        activeColor: '{gray.900}',
        padding: '1rem',
        fontWeight: '500',
        borderRadius: '10px',
        borderWidth: '0px',
        toggleIcon: {
          color: '{text.muted.color}',
          hoverColor: '{text.color}',
          activeColor: '{text.color}',
          activeHoverColor: '{text.color}',
        },
      },
      colorScheme: {
        dark: {
          header: {
            background: '{gray.100}',
            hoverBackground: '{gray.200}',
            activeBackground: '{gray.300}',
            activeHoverBackground: '{gray.200}',
          },
        },
      },
    },
    breadcrumb: {
      ...Lara.components.breadcrumb,
      root: {
        ...Lara.components.breadcrumb.root,
        background: '{gray.50}',
        padding: '0px',
      },
      item: {
        ...Lara.components.breadcrumb.item,
        color: '{gray.600}',
        icon: {
          ...Lara.components.breadcrumb.item.icon,
          color: '{gray.500}',
        },
      },
      separator: {
        color: '{gray.300}',
      },
    },
    inputtext: {
      root: {
        ...Lara.components.inputtext.root,
        borderColor: '{gray.200}',
        borderRadius: '8px',
        paddingX: '12px',
        paddingY: '8px',
      },
    },
    inputnumber: {
      root: {
        ...Lara.components.inputnumber.root,
        borderColor: '{gray.200}',
        borderRadius: '8px',
        paddingX: '12px',
        paddingY: '8px',
      },
    },
    stepper: {
      ...Lara.components.stepper,
      stepNumber: {
        ...Lara.components.stepper.stepNumber,
        size: '1.75rem',
        fontSize: '14px',
      },
      stepTitle: {
        ...Lara.components.stepper.stepTitle,
        activeColor: '{gray.900}',
      },
    },
    panel: {
      ...Aura.components.panel,
      header: {
        ...Aura.components.panel.header,
        toggleIcon: {
          class: 'pi pi-chevron-up'
        }
      }
    },
    tabs: {
      ...Aura.components.tabs,
      tab: {
        ...Aura.components.tabs.tab,
        activeBorderColor: '#C98905',
        activeColor: '#C98905',
        padding: '0 0.625rem 0.75rem 0.625rem',
      },
    },
    toggleswitch: {
      ...Lara.components.toggleswitch,
      root: {
        ...Lara.components.toggleswitch.root,
        width: '2.5rem',
        height: '1.5rem',
      },
      handle: {
        ...Lara.components.toggleswitch.handle,
        size: '1rem',
      },
      colorScheme: {
        ...Lara.components.toggleswitch.colorScheme,
        dark: {
          root: {
            background: '{gray.200}',
            hoverBackground: '{gray.300}',
            checkedBackground: '{primary.500}',
            checkedHoverBackground: '{primary.500}',
          },
          handle: {
            background: 'white',
            hoverBackground: 'white',
            checkedBackground: 'white',
            checkedHoverBackground: 'white',
          },
        },
      },
    },
    select: {
      ...Lara.components.select,
      root: {
        ...Lara.components.inputtext.root,
        borderColor: '{gray.200}',
        borderRadius: '8px',
        paddingX: '12px',
        paddingY: '8px',
      },
    },
    inputgroup: {
      ...Lara.components.inputgroup,
      colorScheme: {
        dark: {
          addon: {
            background: 'white',
            borderColor: '{gray.200}',
            color: '{text.muted.color}',
          },
        },
      },
    },
    button: {
      ...Lara.components.button,
      root: {
        ...Lara.components.button.root,
        borderRadius: '10px',
        sm: {
          paddingX: '14px',
          paddingY: '8px',
          fontSize: '14px',
        },
      },
      colorScheme: {
        ...Lara.components.button.colorScheme,
        dark: {
          ...Lara.components.button.colorScheme.dark,
          root: {
            ...Lara.components.button.colorScheme.dark.root,
            primary: {
              ...Lara.components.button.colorScheme.dark.root.primary,
              hoverBackground: '#E0BA28',
              color: '{gray.900}',
              activeColor: '{gray.900}',
              hoverColor: '{gray.900}',
              activeBackground: '#C8A524',
              activeBorderColor: '#C8A524',
            },
            danger: {
              ...Lara.components.button.colorScheme.dark.root.danger,
              color: 'white',
              hoverColor: 'white',
            },
          },
          outlined: {
            ...Lara.components.button.colorScheme.dark.outlined,
            secondary: {
              ...Lara.components.button.colorScheme.dark.outlined.secondary,
              borderColor: '{gray.300}',
              color: '{gray.700}',
              hoverBackground: '{gray.200}',
              activeBackground: '{gray.300}',
            },
            primary: {
              ...Lara.components.button.colorScheme.dark.outlined.primary,
              borderColor: '{primary.200}',
              color: '{gray.900}',
              activeBackground: '{primary.200}',
              hoverBackground: '{primary.50}',
            },
          },
          text: {
            ...Lara.components.button.colorScheme.dark.text,
            secondary: {
              hoverBackground: '{gray.50}',
              activeBackground: '{gray.200}',
              color: '{gray.600}',
            },
          },
        },
      },
    },
    datatable: {
      ...Lara.components.datatable,
      headerCell: {
        ...Lara.components.datatable.headerCell,
        selectedColor: '{gray.800}',
        selectedBackground: 'unset',
      },
      columnTitle: {
        fontWeight: 'normal',
      },
      colorScheme: {
        ...Lara.components.datatable.colorScheme,

        dark: {
          ...Lara.components.datatable.colorScheme.dark,
          root: {
            borderColor: '{content.border.color}',
          },
          header: {
            background: 'white',
            color: '{text.color}',
          },
          headerCell: {
            background: 'white',
            hoverBackground: 'white',
            color: '{gray.600}',
          },
          footer: {
            background: 'white',
            color: '{text.color}',
          },
          footerCell: {
            background: 'white',
            color: '{text.color}',
          },
          row: {
            stripedBackground: 'white',
          },
          bodyCell: {
            selectedBorderColor: 'white',
          },
        },
      },
    },

    message: {
      ...Lara.components.message,
      content: {
        ...Lara.components.accordion.content,
        padding: '0.5rem 1rem',
      },
    },
  },
};
